import React from "react";
import { Link } from "react-router-dom";

const Pagination = ({
  activePage,
  totalPages,
  onPageChange,
}) => {
  const getVisiblePages = () => {
    const pages = [];

    const start = Math.floor(activePage / 3) * 3;
    const end = Math.min(start + 3, totalPages);

    for (let i = start; i < end; i++) {
      pages.push(i);
    }

    return pages;
  };

  return (
    <div className="dataTables_wrapper">
      <div
        className="dataTables_paginate paging_simple_numbers d-flex align-items-center justify-content-center flex-nowrap"
        role="navigation"
        aria-label="Pagination"
        style={{
          overflowX: "auto",
          overflowY: "hidden",
          whiteSpace: "nowrap",
          gap: "4px",
          padding: "4px 8px",
        }}
      >
        {/* Previous */}
        <Link
          className="paginate_button previous"
          to="#"
          style={{
            minWidth: "36px",
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
          onClick={(e) => {
            e.preventDefault();
            if (activePage > 0) {
              onPageChange(activePage - 1);
            }
          }}
        >
          <i className="fa fa-angle-double-left" aria-hidden="true"></i>
        </Link>

        <span
          className="d-flex align-items-center flex-nowrap"
          style={{
            gap: "4px",
            minWidth: "max-content",
          }}
        >
          {getVisiblePages().map((page) => (
            <Link
              key={page}
              to="#"
              className={`paginate_button ${activePage === page ? "current" : ""
                }`}
              style={{
                minWidth: "36px",
                width: "36px",
                height: "36px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
              onClick={(e) => {
                e.preventDefault();
                onPageChange(page);
              }}
            >
              {page + 1}
            </Link>
          ))}

          {totalPages > 3 &&
            getVisiblePages()[getVisiblePages().length - 1] <
            totalPages - 1 && (
              <>
                <Link
                  to="#"
                  className="paginate_button"
                  style={{
                    minWidth: "36px",
                    width: "36px",
                    height: "36px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                  onClick={(e) => {
                    e.preventDefault();

                    const nextGroup = Math.min(
                      getVisiblePages()[getVisiblePages().length - 1] + 1,
                      totalPages - 1
                    );

                    onPageChange(nextGroup);
                  }}
                >
                  ...
                </Link>

                <Link
                  to="#"
                  className={`paginate_button ${activePage === totalPages - 1 ? "current" : ""
                    }`}
                  style={{
                    minWidth: "36px",
                    width: "36px",
                    height: "36px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    onPageChange(totalPages - 1);
                  }}
                >
                  {totalPages}
                </Link>
              </>
            )}
        </span>

        {/* Next */}
        <Link
          className="paginate_button next"
          to="#"
          style={{
            minWidth: "36px",
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
          onClick={(e) => {
            e.preventDefault();
            if (activePage + 1 < totalPages) {
              onPageChange(activePage + 1);
            }
          }}
        >
          <i className="fa fa-angle-double-right" aria-hidden="true"></i>
        </Link>
      </div>
    </div>
  );
};

export default Pagination;